const tr = {
    formulario: {
        botonEnviar: 'Donar',
        botonEnviando: 'Enviando...'
    },
    errores: {
        formatoEmailIncorrecto: 'Por favor, introduce un email válido',
        importeDebeSerNumero: 'El importe debe ser un número (solo dígitos y punto para la coma)',
        faltaNombreEmpresa: 'El nombre de la empresa es necesario',
        faltaDireccion: 'La direccion es necesaria',
        faltaProvincia: 'La provincia es necesaria',
        faltaPais: 'El país es necesario',
        faltaLocalidad: 'La localidad es necesaria',
        faltaCodigoPostal: 'El código postal es necesario',
        faltaPrivacidad: 'Por favor, acepta la política de privacidad',
        errorEnviandoFormulario: 'Ha habido un error enviando el formulario',
    }
};

export default tr;